<template>
  <div class="auth-wrapper auth-v2">
    <b-row class="auth-inner m-0">

      <!-- Sol panel: login ekraniyla ayni marka paneli. -->
      <b-col
        lg="8"
        class="d-none d-lg-flex align-items-center justify-content-center p-5 login-brand-side"
      >
        <div class="brand-content text-center">
          <b-img
            fluid
            :src="sideImg"
            alt="Vişne Madencilik"
            class="brand-content__logo mb-3"
          />
          <div class="brand-content__title">Lojistik Yönetim Sistemi</div>
          <div class="brand-content__subtitle mb-3">Vişne Madencilik &middot; Öztüre Holding</div>
        </div>

        <div class="brand-side__footer">
          &copy; {{ new Date().getFullYear() }} Öztüre Holding
        </div>
      </b-col>

      <b-col
        lg="4"
        class="d-flex align-items-center auth-bg px-2 p-lg-5"
      >
        <b-col
          sm="8"
          md="6"
          lg="12"
          class="px-xl-2 mx-auto"
        >
          <!-- Talep gonderildikten sonra form yerine bilgilendirme gosterilir.
               Boylece kullanici, gonderdigini bilmeden formu tekrar tekrar
               gondermeye calismaz (ve kotayi bosuna tuketmez). -->
          <template v-if="sent">
            <b-card-title title-tag="h2" class="font-weight-bolder mb-25 login-title">
              Talebiniz alındı 📬
            </b-card-title>
            <b-card-text class="mb-2 text-muted">
              {{ resultMessage }}
            </b-card-text>
            <b-alert variant="secondary" show class="p-1">
              <small>
                Bağlantı <b>1 saat</b> boyunca ve yalnızca <b>bir kez</b> geçerlidir.
                E-posta birkaç dakika içinde ulaşmazsa gereksiz/spam klasörünü kontrol ediniz.
              </small>
            </b-alert>
            <b-button variant="primary" block class="login-submit" :to="{ name:'login' }">
              Giriş ekranına dön
            </b-button>
          </template>

          <template v-else>
            <b-card-title title-tag="h2" class="font-weight-bolder mb-25 login-title">
              Parolanızı mı unuttunuz? 🔑
            </b-card-title>
            <b-card-text class="mb-2 text-muted">
              Hesabınızın e-posta adresini giriniz; parolanızı yeniden belirlemeniz için
              size bir bağlantı gönderelim.
            </b-card-text>

            <validation-observer ref="forgotValidation">
              <b-form class="auth-login-form mt-2" @submit.prevent>
                <b-form-group label="E-Posta" label-for="forgot-email">
                  <validation-provider #default="{ errors }" name="E-Posta" rules="required|email">
                    <b-input-group class="input-group-merge" :class="errors.length > 0 ? 'is-invalid' : null">
                      <b-input-group-prepend is-text>
                        <feather-icon icon="MailIcon"/>
                      </b-input-group-prepend>
                      <b-form-input
                        id="forgot-email"
                        v-model="email"
                        name="forgot-email"
                        class="form-control-merge"
                        :state="errors.length > 0 ? false : null"
                        placeholder="ornek@sirket.com"
                        @keyup.enter="submit"
                      />
                    </b-input-group>
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>

                <b-button
                  type="submit"
                  variant="primary"
                  class="d-flex align-items-center justify-content-center login-submit"
                  block
                  :disabled="loading"
                  @click="submit"
                >
                  <b-spinner small class="mr-50" v-if="loading"></b-spinner>
                  Sıfırlama Bağlantısı Gönder
                  <feather-icon v-if="!loading" icon="SendIcon" size="14" class="ml-50"/>
                </b-button>

                <div class="text-center mt-2">
                  <b-link :to="{ name:'login' }">
                    <feather-icon icon="ChevronLeftIcon" size="14" class="mr-25"/>
                    <small>Giriş ekranına dön</small>
                  </b-link>
                </div>
              </b-form>
            </validation-observer>
          </template>
        </b-col>
      </b-col>
    </b-row>
  </div>
</template>

<script>
/* eslint-disable global-require */
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import {
  BRow, BCol, BLink, BFormGroup, BFormInput, BInputGroupPrepend, BInputGroup,
  BCardText, BCardTitle, BImg, BForm, BButton, BSpinner, BAlert,
} from 'bootstrap-vue'
import { required, email } from '@validations'
import { AuthApi } from '@/api/auth'

export default {
  components: {
    BRow,
    BCol,
    BLink,
    BFormGroup,
    BFormInput,
    BInputGroupPrepend,
    BInputGroup,
    BCardText,
    BCardTitle,
    BImg,
    BForm,
    BButton,
    BSpinner,
    BAlert,
    ValidationProvider,
    ValidationObserver,
  },
  data() {
    return {
      email: '',
      loading: false,
      sent: false,
      resultMessage: '',
      sideImg: require('@/assets/images/logo/ozturelogo.png'),
      required,
      email_rule: email,
    }
  },
  methods: {
    submit() {
      this.$refs.forgotValidation.validate().then(success => {
        if (!success) return
        this.loading = true
        AuthApi.ForgotPassword({ Email: this.email })
          .then(res => {
            this.loading = false
            if (res?.data?.Success) {
              // Sunucu, hesabin kayitli olup olmadigindan bagimsiz olarak ayni
              // mesaji doner; ekran da bu mesaji oldugu gibi gosterir. Aksi halde
              // ekran, hangi e-postalarin sistemde kayitli oldugunu sizdiran bir
              // sorgulama aracina donerdi.
              this.sent = true
              this.resultMessage = res.data.Message
            } else {
              // Basarisiz tek durum kota asimi; kullaniciya gosterilmeli.
              this.$result(res)
            }
          })
          .catch(err => {
            this.loading = false
            this.$result(null, err)
          })
      })
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/pages/page-auth.scss';
@import '@/assets/scss/auth-brand.scss';
</style>
